import { useState } from 'react'
import { Navigate, useSearchParams } from 'react-router-dom'
import { deleteAccount } from '../api/auth'
import { TokenActionCard } from '../components/TokenActionCard'
import { Button } from '../components/ui/Button'
import { Field, Input } from '../components/ui/Field'
import { useT } from '../i18n/context'
import { errText } from '../lib/errors'
import { useAuthStore } from '../stores/auth'
import { toast } from '../stores/toast'

export function DeleteAccountPage() {
    const t = useT()
    const [params] = useSearchParams()
    const token = params.get('token') ?? ''
    const clear = useAuthStore(s => s.clear)
    const [email, setEmail] = useState('')
    const [busy, setBusy] = useState(false)
    const [done, setDone] = useState(false)
    const [error, setError] = useState<string | null>(null)

    if (!token) {
        return (
            <TokenActionCard state='error' title={t('deleteAccount.invalidTitle')}>
                <p>{t('deleteAccount.noToken')}</p>
            </TokenActionCard>
        )
    }

    if (done) return <Navigate to='/login' replace />

    const submit = async (e: React.FormEvent) => {
        e.preventDefault()
        setError(null)
        setBusy(true)
        try {
            await deleteAccount(token, email.trim())
            clear()
            toast.info(t('deleteAccount.deleted'))
            setDone(true)
        } catch (err) {
            setError(errText(err))
            setBusy(false)
        }
    }

    return (
        <TokenActionCard title={t('deleteAccount.title')}>
            <p>{t('deleteAccount.desc')}</p>
            <form onSubmit={submit} className='space-y-3 text-left'>
                <Field label={t('deleteAccount.confirmEmail')}>
                    <Input
                        type='email'
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                        required
                        autoComplete='email'
                    />
                </Field>
                {error && (
                    <p
                        role='alert'
                        className='rounded-lg bg-red-50 dark:bg-red-950/60 px-3 py-2 text-sm text-red-700 dark:text-red-300'
                    >
                        {error}
                    </p>
                )}
                <Button
                    type='submit'
                    variant='danger'
                    loading={busy}
                    className='w-full'
                >
                    {t('deleteAccount.button')}
                </Button>
            </form>
        </TokenActionCard>
    )
}
